import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SubOwnersModal from "../../../../../modals/yourAssets/BOA/SubOwnersModal";
import DeleteDataModal from "../../../../../modals/yourAssets/BOA/DeleteDataModal";
import { SecondaryButton } from "../../../../../common/Buttons";
import {
  updateRSUser,
  addRSUsers,
} from "../../../../../services/yourAssets/RealEstateServices";
import { Toaster, toast } from "react-hot-toast";
import SimpleBarReact from "simplebar-react";
import ImportData from "../ImportData";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../../constants/constants";
import { updateAuditTrails } from "../../../../../services/auditTrails";
import ModifiedByToaster from "../../../../../common/ModifiedByToaster";
import {
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getClientIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../../../utils/Utilities";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../../../../yourAssets/BOA/FilePreviewModal";
import DeleteFileModal from "../../../../../modals/yourAssets/BOA/DeleteFileModal";
import { deleteUserMediaBOA } from "../../../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getFile } from "../../../../../services/yourAssets/BankBalancesServices";
import FormattedDate from "../../../../../utils/TabelDateFormat";

const Summary = (props) => {
  let clientId = getClientIdFromLocalStorage();
  const { t, i18n } = useTranslation();
  const propertyCurrentStatus = [
    {
      id: 1,
      name: t("rs-input-resident-3"),
      image: "/assets/icons/partner-male.png",
      imageName: "My Self",
    },
    {
      id: 2,
      name: t("rs-input-resident-1"),
      image: "/assets/icons/child-male.png",
      imageName: "Kids",
    },
    {
      id: 3,
      name: t("rs-input-resident-2"),
      image: "/assets/icons/rent.png",
      imageName: "Renting",
    },
    {
      id: 4,
      name: "Grand Kids",
      image: "/assets/icons/child-male.png",
      imageName: "Grand Kids",
    },
  ];
  const { id } = useParams();
  const {
    selectedProperties,
    setSelectedProperties,
    next,
    handlePostApiFlag,
    disableContinueButton,
    makePropertyData,
  } = props;
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.realEstate
  );
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [focusedProperty, setFocusedProperty] = useState({});
  const [selectedSubOwner, setSelectedSubOwner] = useState({});
  const [selectedSubOwnerIndex, setSelectedSubOwnerIndex] = useState("");
  const [propertyTypeId, setPropertyTypeId] = useState("");
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);

  const dispatch = useDispatch();

  let bgColorToggle = true;

  const handleUpdates = async (data) => {
    await updateAuditTrails(data, id);
  };
  const ImageBox = (subOwner) => {
    let imagesArray = subOwner?.propertyType.map((el, i) => {
      let imageSrc = propertyCurrentStatus?.find(
        (item) => item.imageName === el.label
      );
      return (
        <img key={el.label} src={imageSrc?.image} width="45px" alt="box" />
      );
    });

    return <div>{imagesArray}</div>;
  };
  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[0] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[0]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[0] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[0]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[0] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[0]?.toLowerCase()
        )
        .map((item) => item)
    );
    makePropertyData();
  }, []);
  const reInitializeSelection = () => {
    setPropertyTypeId("");
    setFocusedProperty({});
    setSelectedSubOwner({});
    setSelectedSubOwnerIndex("");
    for (let i = 0; i < selectedProperties?.length; i++) {
      const elementI = selectedProperties[i];
      if (elementI?.data?.length > 0) {
        for (let j = 0; j < elementI?.data?.length; j++) {
          const elementJ = elementI?.data[j];
          if (elementJ.name && elementJ?.sharesData?.length > 0) {
            for (let k = 0; k < elementJ?.sharesData?.length; k++) {
              const elementK = elementJ?.sharesData[k];
            }
          }
        }
      }
    }
  };
  const handleSubOwnersModalOpen = () => setShowSubOwnersModal(true);
  const handleSubOwnersModalClose = () => setShowSubOwnersModal(false);
  const handleAddPropertyData = (item, propertyId, subOwner, subOwnerIndex) => {
    handleSubOwnersModalOpen();
    setPropertyTypeId(propertyId);
    setFocusedProperty(item);
    setSelectedSubOwner(subOwner);
    setSelectedSubOwnerIndex(subOwnerIndex);
  };
  const handleDeletePropertyData = (
    item,
    propertyId,
    subOwner,
    subOwnerIndex
  ) => {
    setPropertyTypeId(propertyId);
    setFocusedProperty(item);
    setSelectedSubOwner(subOwner);
    setSelectedSubOwnerIndex(subOwnerIndex);
    setShowDeleteModal(true);
  };
  const deleteSubOwnersData = (
    propertyTypeId,
    selectedSubOwnerIndex,
    subPropertyKey
  ) => {
    let updatedProperty;
    if (selectedSubOwnerIndex === 0 || !selectedSubOwnerIndex) {
      updatedProperty = selectedProperties.map((el) => {
        if (el.id === propertyTypeId) {
          let indeexToDelete = el.data.findIndex(
            (item) => item.key === subPropertyKey
          );
          el.data.splice(indeexToDelete, 1);
        }
        return el;
      });
    } else {
      updatedProperty = selectedProperties.map((el) => {
        if (el.id === propertyTypeId) {
          let dataArrayIndex = el.data.findIndex(
            (item) => item.key === subPropertyKey
          );
          el.data[dataArrayIndex].sharesData.splice(selectedSubOwnerIndex, 1);
        }
        return el;
      });
    }
    setSelectedProperties(updatedProperty);
    setShowDeleteModal(false);
    handleSubOwnersModalClose();
    reInitializeSelection();
  };

  const addSubOwnersData = (
    subOwnersData,
    propertyTypeId,
    subPropertyKey,
    selectedSubOwnerIndex
  ) => {
    if (subOwnersData.propertyType.length > 0) {
      let arr = [];
      subOwnersData.propertyType.forEach((elem) => {
        arr = [...arr, { ...elem, label: t(getKeyFromText(elem.label)) }];
      });
      subOwnersData = { ...subOwnersData, propertyType: arr };
    }
    let updatedProperty = selectedProperties.map((el) => {
      if (el.id === propertyTypeId) {
        if (selectedSubOwnerIndex || selectedSubOwnerIndex === 0) {
          el.data[subPropertyKey - 1].sharesData[selectedSubOwnerIndex] =
            subOwnersData;
        } else {
          el.data[subPropertyKey - 1].sharesData.push(subOwnersData);
        }
      }
      return el;
    });
    setSelectedProperties(updatedProperty);
    reInitializeSelection();
  };
  const countTotalValueOfProperty = () => {
    let totalCount = 0;

    for (let i = 0; i < selectedProperties.length; i++) {
      let elementI = selectedProperties[i];
      if (elementI.data && elementI.data.length > 0) {
        for (let j = 0; j < elementI.data.length; j++) {
          let elementJ = elementI.data[j];
          if (elementJ.sharesData && elementJ.sharesData.length > 0) {
            let elementK = elementJ.sharesData[0];
            totalCount += +elementK.valueOfTheProperty;
          }
        }
      }
    }
    return totalCount.toLocaleString("de-DE");
  };

  const handleMainSubmit = async () => {
    setBtnLoading(true);
    let selectedPropertiesCopy = [...selectedProperties];
    let array = [];
    for (let i = 0; i < selectedPropertiesCopy.length; i++) {
      const elementI = selectedPropertiesCopy[i];
      for (let j = 0; j < elementI.data.length; j++) {
        const elementJ = elementI.data[j];
        let obj = {
          realEstateCategoryId: "",
          realEstateId: "",
          valueOfProperty: "",
          nameOfOwner: "",
          ownerShipPercentage: 0,
          dateOfValue: "",
          isLiving: false,
          isKidsLiving: false,
          IsGrandKidsLiving: false,
          isArea200: false,
          isRenting: false,
          subRealEstates: [],
          kidNodes: [],
          grandKidNodes: [],
        };

        obj.realEstateCategoryId = elementI.id;
        obj.realEstateId =
          elementJ.sharesData[0]?.realEstateId?.length > 10
            ? elementJ.sharesData[0]?.realEstateId
            : "";
        obj.userId = elementJ.sharesData[0]?.userId;
        obj.nameOfOwner = elementJ.sharesData[0]?.nameOfOwners;

        obj.ownerShipPercentage = elementJ.sharesData[0]?.ownership;

        obj.valueOfProperty = elementJ.sharesData[0]?.valueOfTheProperty;

        obj.dateOfValue = elementJ.sharesData[0]?.date;

        obj.isArea200 = elementJ.sharesData[0]?.areaLT200ms;

        for (let k = 0; k < elementJ.sharesData[0]?.propertyType?.length; k++) {
          const element = elementJ.sharesData[0]?.propertyType[k];
          if (element.label === "My Self") {
            obj.isLiving = true;
          }
          if (element.label === "Kids") {
            obj.isKidsLiving = true;
          }
          if (element.label === "Grand Kids") {
            obj.IsGrandKidsLiving = true;
          }
          if (element.label === "Renting") {
            obj.isRenting = true;
          }
        }
        let listForChilds = [];
        let listForGrandChilds = [];
        for (let k = 0; k < elementJ.sharesData[0]?.childs?.length; k++) {
          const element = elementJ.sharesData[0]?.childs[k];
          if (element.type === "child") {
            let obj = {
              familyTreeId: element.id,
              name: element.value,
            };
            listForChilds.push(obj);
          } else {
            let obj = {
              familyTreeId: element.id,
              name: element.value,
            };
            listForGrandChilds.push(obj);
          }
        }

        obj.kidNodes = listForChilds;
        obj.grandKidNodes = listForGrandChilds;

        let [...restObjs] = elementJ.sharesData;
        for (let k = 1; k < restObjs.length; k++) {
          let elementK = restObjs[k];
          let subObj = {
            valueOfTheProperty: 0,
            nameOfOwner: "",
            ownerShipPercentage: 0,
            valueOfProperty: "",
            dateOfValue: "",
          };
          subObj.dateOfValue = elementK.date;
          subObj.nameOfOwner = elementK.nameOfOwners;
          subObj.ownerShipPercentage = elementK.ownership;
          subObj.valueOfProperty = elementK.valueOfTheProperty;
          subObj.subRealEstateId =
            elementK.subRealEstateId?.length > 10
              ? elementK.subRealEstateId
              : "";
          subObj.realEstateId =
            elementJ.sharesData[0]?.realEstateId?.length > 10
              ? elementJ.sharesData[0]?.realEstateId
              : "";

          obj.subRealEstates.push(subObj);
        }

        array.push(obj);
      }
    }
    let result = {};
    if (handlePostApiFlag) {
      result = await addRSUsers(array, id);
    } else {
      result = await updateRSUser(array, id);
    }
    if (result?.success) {
      next();
    } else {
      toast.error(t(getKeyFromText(result?.message)));
    }
    setBtnLoading(false);
  };
  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: clientId,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(clientId, boaUserMediaFileId);
    if (result?.success) {
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
    }
  };
  const translatePropertyWithCount = (name) => {
    const keyWords = name.split(" ");
    const count = keyWords.pop();
    const propertyName = t(keyWords.join("-").toLowerCase()) + " " + count;
    return propertyName;
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);
  return (
    <React.Fragment>
      <Toaster />
      {showSubOwnersModal && (
        <SubOwnersModal
          open={showSubOwnersModal}
          handleOpen={() => handleSubOwnersModalOpen()}
          handleClose={() => handleSubOwnersModalClose()}
          focusedProperty={focusedProperty}
          propertyTypeId={propertyTypeId}
          addSubOwnersData={addSubOwnersData}
          deleteSubOwnersData={deleteSubOwnersData}
          selectedSubOwner={selectedSubOwner}
          selectedSubOwnerIndex={selectedSubOwnerIndex}
        />
      )}
      {showDeleteModal && (
        <DeleteDataModal
          open={showDeleteModal}
          handleClose={() => {
            setShowDeleteModal(false);
          }}
          selectedSubOwnerIndex={selectedSubOwnerIndex}
          focusedProperty={focusedProperty}
          accountTypeId={propertyTypeId}
          deleteData={deleteSubOwnersData}
          user={translatePropertyWithCount(focusedProperty.name)}
        />
      )}
      <Box className="real-estate-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <ImportData
              sectionId={1}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          <TableContainer
            sx={{ paddingBottom: "0 !impotant" }}
            component={Paper}
            className="summary-table summary-table-realestate"
          >
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("rs-table-heading-1")} </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">{t("rs-table-heading-2")}</TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-3")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedProperties?.map((el) =>
                  el.data.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {item.sharesData.length > 0 ? (
                          item.sharesData.map(
                            (subOwner, subOwnerIndex, arr) => {
                              return (
                                <TableRow
                                  sx={{
                                    backgroundColor: `${
                                      bgColorToggle
                                        ? "color.smokeWhite"
                                        : "color.white"
                                    }`,
                                  }}
                                  key={subOwner?.realEstateId}
                                  className={
                                    updatedIds.includes(
                                      subOwner?.realEstateId
                                    ) ||
                                    updatedIds.includes(
                                      subOwner?.subRealEstateId
                                    )
                                      ? "highlighted-table-row"
                                      : ""
                                  }
                                >
                                  <TableCell>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {subOwnerIndex === 0
                                        ? `${t(el.translationKey)} ${item.key}`
                                        : null}
                                      {subOwnerIndex === 0 &&
                                      subOwner?.propertyType?.length > 0
                                        ? ImageBox(subOwner)
                                        : null}
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginTop: "auto 0 !important",
                                      }}
                                    >
                                      <Box>{`${
                                        subOwner?.nameOfOwners
                                          ? subOwner.nameOfOwners
                                          : "-"
                                      }`}</Box>
                                      {subOwnerIndex === 0 ? (
                                        <Box>
                                          <IconButton
                                            sx={{
                                              cursor: "pointer",
                                            }}
                                            aria-label="Add"
                                            size="small"
                                            onClick={() =>
                                              handleAddPropertyData(item, el.id)
                                            }
                                          >
                                            <AddCircleOutlineSharpIcon />
                                          </IconButton>
                                        </Box>
                                      ) : null}
                                    </Box>
                                  </TableCell>
                                  <TableCell>{`${
                                    subOwner?.ownership
                                      ? subOwner.ownership + "%"
                                      : "-"
                                  }`}</TableCell>
                                  <TableCell>
                                    {(
                                      <>
                                        {Number(
                                          subOwner.valueOfTheProperty
                                        ).toLocaleString("de-DE")}
                                        €
                                      </>
                                    ) ?? "-"}
                                  </TableCell>
                                  {/* <TableCell>{`${
                                    subOwner?.date
                                      ? subOwner.date
                                          .slice(0, 10)
                                          .split("-")
                                          .reverse()
                                          .join("-")
                                      : "-"
                                  }`}</TableCell> */}
                                  <TableCell>
                                    <FormattedDate
                                      date={subOwner.date}
                                      language={i18n.language}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      sx={{ cursor: "pointer" }}
                                      aria-label="add"
                                      size="small"
                                      onClick={() =>
                                        handleAddPropertyData(
                                          item,
                                          el.id,
                                          subOwner,
                                          subOwnerIndex
                                        )
                                      }
                                    >
                                      <img
                                        src="/assets/icons/edit-icon.svg"
                                        alt="edit"
                                      />
                                    </IconButton>

                                    <IconButton
                                      sx={{ cursor: "pointer" }}
                                      aria-label="delete"
                                      size="small"
                                      onClick={() => {
                                        handleDeletePropertyData(
                                          item,
                                          el.id,
                                          subOwner,
                                          subOwnerIndex
                                        );
                                      }}
                                    >
                                      <img
                                        src="/assets/icons/delete-icon.svg"
                                        alt="delete"
                                      />
                                    </IconButton>
                                  </TableCell>
                                  {(bgColorToggle = !bgColorToggle)}
                                </TableRow>
                              );
                            }
                          )
                        ) : (
                          <TableRow
                            sx={{
                              backgroundColor: `${
                                bgColorToggle
                                  ? "color.smokeWhite"
                                  : "color.white"
                              }`,
                            }}
                          >
                            <TableCell>{`${t(el.translationKey)} ${
                              item.key
                            }`}</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleAddPropertyData(item, el.id);
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>

                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  handleDeletePropertyData(item, el.id, {}, 0);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </TableCell>
                            {(bgColorToggle = !bgColorToggle)}
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })
                )}

                <TableRow sx={{ background: "#dfc8db" }}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                  >{`${t()} ${countTotalValueOfProperty()} € `}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          className="save-countinue-btn"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleMainSubmit}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
